module.exports = __webpack_public_path__ + "static/img/des1.1937782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/buycardgetcoupon/des1.png
// module id = VSYx
// module chunks = 0